import React, { useState } from 'react'
import { AccVer } from './AccVer';
import OTPVerification from './OTPVerification';
import { apiClient } from '../services/ApiServices';
import axios from 'axios';
import ConfirmCustDeatil from './ConfirmCustDeatil';

function FaydaVerification() {
 const [currentStep, setCurrentStep] = useState('account'); 
  const [accountNumber, setAccountNumber] = useState('');
  const [cbsData, setCbsData] = useState(null);
  const [nationalIdData, setNationalIdData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
 // const redirect = "http://172.21.22.6:4200/userprofile";

  const handleAccountSubmit = (account, data) => {
    setAccountNumber(account);
    setCbsData(data);
    setCurrentStep('otp');
  };

   const handleOTPVerified = () => {
    setCurrentStep('confirm');
  };

  const handleConfirmContinue = async() => {
    const redirect = "https://nid.gohbetbank.com/callback/verifayda";
    setIsLoading(true);
    try {
   const response = await apiClient.get(`/customer/verification/fayda/auth-url?customerId=${cbsData?.data.customerId}&redirectUri=${redirect}`);
   console.log('Redirecting to:', response.data);
   console.log('Redirect URL:', response.data.data.authUrl);
   const redirectUrl = response.data.data.authUrl;
  window.location.href = redirectUrl;
    } catch (error) {
        console.error('unable to redirect:', error);
    }finally {
        setIsLoading(false);
    } 
  };

//   const handleOTPVerified = () => {
//     try {
//         //const response = axios.get(`http://172.21.22.6:7272/api/v1/esignet/get-auth-url?redirect_uri=${redirect}`);
//         const response = apiClient.get('/fayda');   
//         console.log('Redirecting to:', response.data.url);
//         //window.location.href = redirectUrl;
        
//       //setCurrentStep('nationalId');

//     } catch (error) {
//       console.error('unable to redirect:', error);
//     }
//   };

  const handleNationalIDSubmit = (data) => {
    setNationalIdData(data);
    setCurrentStep('comparison');
  };

  const handleStartOver = () => {
    setCurrentStep('account');
    setAccountNumber('');
    setCbsData(null);
    setNationalIdData(null);
  };
    if (isLoading) {
      return (
      
          <div className="flex items-center justify-center h-96">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
      
      );
    }
  

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          {/* <header className="text-center mb-12">
            <h1 className="text-4xl font-bold text-slate-800 mb-2">Customer Verification Portal</h1>
            <p className="text-slate-600">Secure account verification and data validation</p>
          </header> */}

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            {currentStep === 'account' && (
                <AccVer onSubmit={handleAccountSubmit} />
              
            )}
            {currentStep === 'otp' && (
              <OTPVerification
                data={cbsData}
                onVerified={handleOTPVerified}
              />
              
            )}
              {currentStep === 'confirm' && cbsData && (
              <ConfirmCustDeatil
                data={cbsData}
                onContinue={handleConfirmContinue}
              />
          
            )}
          </div>
        </div>
      </div>
    </div>
  );
}


export default FaydaVerification